import http from '../../common/Http'

/** 用户个人信息 */
function getProfile (eamil) {
  let url = '/v1/user/profile'
  return http("get", url, {
      email: eamil
  })
}
 /** 用户个人信息-编辑 */
function editProfile (params) {
  let url = '/v1/user/profile/edit'
  return http("post", url, params)
}
/** 用户-密码-验证 */
function passwordReset (params) {
  let url = '/v1/user/password/reset'
  return http("post", url, params)
}

export {
  getProfile,
  editProfile,
  passwordReset
}

